import {createLazyFileRoute} from '@tanstack/react-router'

import FoodOrders from '@/views/Account/FoodOrders/FoodOrders'

export const Route = createLazyFileRoute('/_account/food-orders/')({
  component: FoodOrders,
})
